// import React, { useEffect, useState } from "react";
// import { Formik, Form } from "formik";
// import { Toast } from "../../../CustomComponent/toast";
// import performRequest from "../../../api/request";
// import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
// import { HydroponicMaterialInfo } from "../../../SchemaInfo/info";
// import { AddItemHydroponicMaterial } from "../../../Schemas/Farm support/farmer_inventory_schema";
// import CustomInput from "../../../CustomComponent/custom_input";
// import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
// import { roundOffCost } from "../../../Components/Functions/amt.fun";
// import { useNavigate } from "react-router";
// import { useSelector } from "react-redux";
// import CustomViewButton from "../../../CustomComponent/custom_view_button";
// import { IoPeopleSharp } from "react-icons/io5";
// import CustomSelect from "../../../CustomComponent/custom_select";
// import { extractDate } from "../../../Components/Functions/date.fun";
// const tableHead = [
//   "Sr.",
//   "Business name",
//   "Contact Number",
//   "contact Email",
//   "state",
//   "Actions",
// ];

// const HydroponicInventoryTable = ({
//   data = [],
//   setRefresh,
//   onTotalAmountChange,
//   currentPage,
//   itemsPerPage,
// }) => {
//   const store = useSelector((store) => store.login.user);
//   const [inStock, setInStock] = useState([]);
//   const [thresholdLimit, setThresholdLimit] = useState([]);
//   const [cost, setCost] = useState([]);
//   const [vendor, setVendor] = useState([]);
//   const [vendorList, setVendorList] = useState([]);
//   const [openModel, setOpenModel] = useState(false);
//   const [history, setHistory] = useState(null);
//   const navigate = useNavigate();
//   useEffect(() => {
//     setInStock(data?.map((item) => item?.inStock ?? ""));
//     setThresholdLimit(data?.map((item) => item?.thresholdLimit ?? ""));
//     setCost(data?.map((item) => item?.cost ?? ""));
//   }, [data]);

//   useEffect(() => {
//     if (openModel) {
//       if (vendor.length > 0) {
//         let ele = document.getElementById("open-modal-data");
//         ele.click();
//       } else {
//         alert("No vendor available for this product");
//       }
//     }
//     setOpenModel(false);
//   }, [vendor]);

//   useEffect(() => {
//     if (openModel) {
//       if (history && history.length > 0) {
//         let ele = document.getElementById("open-modal-history");
//         ele.click();
//       } else {
//         alert("No history available for this product");
//       }
//     }
//     setOpenModel(false);
//   }, [history]);

//   useEffect(() => {
//     const totalAmount = data.reduce((total, item, index) => {
//       return (
//         total + parseFloat(inStock[index] || 0) * parseFloat(cost[index] || 0)
//       );
//     }, 0);
//     onTotalAmountChange(totalAmount);
//   }, [data, inStock, cost, onTotalAmountChange]);
//   const goToView = (id) => {
//     navigate(`/purchase-vendor-management/view-vendor/${id}`);
//   };
//   useEffect(() => {
//     performRequest("GET", "/poDcPi/getAllVendorList")
//       .then((res) => setVendorList(res.data))
//       .catch((err) => CustomErrorResponse(err));
//   }, []);

//   const getPrice = (inStock, costperUnit, weight, unit) => {
//     const weightNew = parseFloat(weight);
//     if (
//       (unit === "kg" ||
//         unit === "grams" ||
//         unit === "ltr" ||
//         unit === "ml" ||
//         unit === "mtr") &&
//       !isNaN(weightNew) &&
//       weightNew > 0
//     ) {
//       return weightNew * costperUnit * inStock;
//     }
//     return costperUnit * inStock;
//   };

//   const handelSubmit = async (id, item, values, { resetForm }) => {
//     try {
//       const previousCost = parseFloat(item?.cost) || 0;
//       const previousInStock = parseFloat(item?.inStock) || 0;
//       const newCost = parseFloat(values?.cost) || 0;
//       const newInStock = parseFloat(values?.inStock) || 0;
//       if (!newCost || !newInStock) {
//         Toast("error", "please add cost and stock items!");
//         return;
//       }
//       const updatedCost =
//         (previousInStock * previousCost + newInStock * newCost) /
//         (previousInStock + newInStock);

//       const updatedStock = previousInStock + newInStock;
//       let stockUpdateHistory = [];
//       if (item.stockUpdateHistory) {
//         stockUpdateHistory = item.stockUpdateHistory;
//       }

//       stockUpdateHistory.push({
//         cost: newCost,
//         inStock: newInStock,
//         costFromVendor: values.costFromVendor,
//         date: new Date(),
//         invoiceNumber: values.invoiceNumber,
//         generatedBy: store.Name,
//       });
//       const updateData = {
//         inStock: updatedStock,
//         cost: parseFloat(updatedCost),
//         stockUpdateHistory,
//       };
//       await performRequest(
//         "PATCH",
//         `/materialPlanning/updateMaterialList/${id}`,
//         updateData
//       );

//       Toast("success", "Inventory updated successfully!");

//       setCost((prev) => {
//         if (!Array.isArray(prev)) return prev;
//         const updated = [...prev];
//         updated[id] = Number(updatedCost.toFixed(2));
//         return updated;
//       });

//       resetForm();
//       setRefresh((prev) => !prev);
//     } catch (err) {
//       CustomErrorResponse(err);
//     }
//   };

//   const returnClassnameBg = (inStockValue, thresholdValue) => {
//     return inStockValue > thresholdValue
//       ? { backgroundColor: "rgba(144, 238, 144, 0.2)" }
//       : { backgroundColor: "rgba(255, 99, 71, 0.2)" };
//   };

//   const returnClassnameBadgeBg = (hydroponicType) => {
//     switch (hydroponicType) {
//       case "flatbed":
//         return "text-white badge bg-primary mt-1 me-2"; // Blue
//       case "dutch_bucket":
//         return "text-white badge bg-success mt-1 me-2"; // Green
//       case "planters":
//         return "text-white badge bg-danger mt-1 me-2"; // Red
//       case "growbags":
//         return "text-white badge bg-info mt-1 me-2"; // Cyan
//       default:
//         return "text-white badge bg-warning mt-1 me-2"; // Yellow (default)
//     }
//   };

//   const returnClassnameBadgeBgSize = (size) => {
//     switch (size) {
//       case "Small":
//         return "badge bg-green-lt";
//       case "Medium":
//         return "badge bg-azure-lt";
//       case "Large":
//         return "badge bg-yellow-lt";
//       case "Extra Large":
//         return "badge bg-red-lt";
//       case "Double Extra Large":
//         return "badge bg-cyan-lt";
//       default:
//         return "badge bg-purple-lt";
//     }
//   };

//   const clampStyle = {
//     display: "-webkit-box",
//     WebkitBoxOrient: "vertical",
//     WebkitLineClamp: 2,
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//   };

//   return (
//     <div className="table-responsive">
//       <table className="table table-vcenter">
//         <thead>
//           <tr>
//             <th style={{ minWidth: "170px" }}>SR./ Image/ SKU</th>
//             <th style={{ minWidth: "200px" }}>Item/ size/ type</th>
//             <th style={{ minWidth: "250px" }}>Specifications</th>
//             <th>InStock/ Stock Value</th>
//             <th className="text-center">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data?.map((item, index) => {
//             const inStockValue = parseFloat(inStock[index]) || 0;
//             const thresholdValue = parseFloat(thresholdLimit[index]) || 0;
//             const Index = (currentPage - 1) * itemsPerPage + index + 1;

//             return (
//               <tr
//                 className="text-uppercase fs-5"
//                 key={item?.id}
//                 style={returnClassnameBg(inStockValue, thresholdValue)}
//               >
//                 <td>
//                   <img
//                     width="140px"
//                     length="140px"
//                     src={item?.image}
//                     alt="Not Uploaded"
//                   />
//                 </td>
//                 <td style={{ maxWidth: "200px" }}>
//                   <span className="fs-5 mt-2">
//                     <b>
//                       {Index}) {item?.sku}
//                     </b>
//                   </span>
//                   <br className="m-0"></br>
//                   <span>
//                     <b> {item?.item || "N/A"}</b>
//                   </span>
//                   <br />
//                   <span>
//                     Size:{" "}
//                     <b className={returnClassnameBadgeBgSize(item?.size)}>
//                       {item?.size}
//                     </b>
//                   </span>
//                   <br />
//                   {item?.location && (
//                     <>
//                       <span className="m-0" style={{ fontSize: "11px" }}>
//                         <b>Location: </b> {item.location || "-"}
//                       </span>
//                       <br className="m-0" />
//                     </>
//                   )}
//                   {item?.rackId && (
//                     <>
//                       <span className="m-0" style={{ fontSize: "11px" }}>
//                         <b>Rack Id: </b> {item?.rackId || "-"}{" "}
//                       </span>
//                       <br className="m-0" />
//                     </>
//                   )}
//                   {item?.iteminList ? (item?.hydroponicTypeNew ?? []).map((type, index) => (
//                     <>
//                       <span
//                         key={index}
//                         className={returnClassnameBadgeBg(type)}
//                       >
//                         {type || "N/A"}
//                       </span>
//                     </>
//                   )):""}
//                 </td>
//                 <td style={{ width: "10%" }}>
//                   <div className="d-flex flex-wrap">
//                     {(item?.specificationsNew ?? []).map((type, index) =>
//                       type.specification ? (
//                         <p className="p-0 m-0">
//                           <b className="text-capitalize">{type?.type}</b>:{" "}
//                           {type?.specification || "N/A"}
//                         </p>
//                       ) : (
//                         "-"
//                       )
//                     )}
//                   </div>
//                   {item?.productSpecification && <div className="text-capitalize"><b>Technical Specification: </b><span className="text-uppercase">{item?.productSpecification}</span></div>}
//                 </td>
//                 <td>
//                   <span className="fs-3" style={{fontWeight:"900"}}>
//                     Instock:{" "}
                    
//                       {item?.inStock || 0} / {item?.thresholdLimit || 0}
                 
//                   </span>
//                   <br />
//                   <span>
//                     Cost:{" "}
//                     <b>
//                       ₹{item?.cost || 0}
//                       {item?.proUnit ? `/ ${item?.proUnit}` : ""}
//                     </b>
//                   </span>
//                   <br />
//                   <span>
//                     Total:{" "}
//                     <b>
//                       {roundOffCost(
//                         getPrice(
//                           item?.inStock,
//                           item?.cost,
//                           item?.weight,
//                           item?.proUnit
//                         )
//                       )}
//                     </b>
//                   </span>
//                   <br />
//                   {item?.brandName && <span className="m-0 badge badge bg-azure-lt border mt-1">
//                     Brand Name:{" "}
//                     <b>
//                       {item?.brandName}
//                     </b>
//                   </span>}
//                 </td>

//                 <td>
//                   <div className="row g-2">
//                     <div className="col-12">
//                       <button
//                         className="btn btn-sm btn-primary text-uppercase w-100"
//                         data-bs-toggle="modal"
//                         data-bs-target={`#modal-team-${item?.id}`}
//                       >
//                         Add Item
//                       </button>
//                     </div>

//                     <div className="col-lg-3">
//                       <button className="btn btn-sm btn-primary text-uppercase w-100">
//                         <IoPeopleSharp
//                           style={{ fontSize: "16px", color: "white" }}
//                           onClick={() => {
//                             setOpenModel(true);
//                             setVendor(item.vendorDealsIn || []);
//                           }}
//                         />
//                       </button>
//                     </div>
//                     <div className="col-lg">
//                       {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
//                         store.Role === process.env.REACT_APP_ROLE_ADMIN ||
//                         store.Role === process.env.REACT_APP_ROLE_PURCHASE) && (
//                         <button
//                           className="btn btn-sm btn-primary text-uppercase w-100"
//                           onClick={() =>
//                             navigate(
//                               `/hydroponic-material-inventory/edit/${item.id}`
//                             )
//                           }
//                         >
//                           Edit Item
//                         </button>
//                       )}
//                     </div>
//                     <div className="col-lg">
//                       {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
//                         store.Role === process.env.REACT_APP_ROLE_ADMIN ||
//                         store.Role === process.env.REACT_APP_ROLE_PURCHASE) && (
//                         <button
//                           className="btn btn-sm btn-primary text-uppercase w-100"
//                           onClick={() => {
//                             setOpenModel(true);
//                             setHistory(item.stockUpdateHistory);
//                           }}
//                         >
//                           History
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                   <br />
//                   <div
//                     className="modal modal-blur fade"
//                     id={`modal-team-${item?.id}`}
//                     tabIndex="-1"
//                     role="dialog"
//                     aria-hidden="true"
//                   >
//                     <Formik
//                       initialValues={HydroponicMaterialInfo}
//                       validationSchema={AddItemHydroponicMaterial}
//                       onSubmit={(values, actions) =>
//                         handelSubmit(item?.id, item, values, actions)
//                       }
//                       enableReinitialize
//                     >
//                       {(props) => (
//                         <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
//                           <div className="modal-dialog modal-dialog-centered w-100">
//                             <div className="modal-content">
//                               <div className="modal-header">
//                                 <h5 className="modal-title">Add Items</h5>
//                                 <button
//                                   type="button"
//                                   className="btn-close"
//                                   data-bs-dismiss="modal"
//                                   aria-label="Close"
//                                 ></button>
//                               </div>
//                               <div className="modal-body">
//                                 <div className="mb-3">
//                                   <label className="form-label required">
//                                     Add item in stock
//                                   </label>
//                                   <CustomInput name="inStock" type="text" />
//                                   {props.touched.inStock &&
//                                     props.errors.inStock && (
//                                       <p className="text-danger">
//                                         {props.errors.inStock}
//                                       </p>
//                                     )}
//                                 </div>
//                                 <div className="mb-3">
//                                   <label className="form-label required">
//                                     Cost per unit
//                                   </label>
//                                   <CustomInput name="cost" type="text" />
//                                   {props.touched.cost && props.errors.cost && (
//                                     <p className="text-danger">
//                                       {props.errors.cost}
//                                     </p>
//                                   )}
//                                 </div>
//                                 <div className="mb-3">
//                                   <label className="form-label">
//                                     Cost from vendor
//                                   </label>
//                                   <CustomSelect
//                                     type="text"
//                                     name="costFromVendor"
//                                   >
//                                     <option value="">Select</option>
//                                     {vendorList?.map((item) => {
//                                       return (
//                                         <option
//                                           key={item.id}
//                                           value={item.businessName}
//                                         >
//                                           {item.businessName}
//                                         </option>
//                                       );
//                                     })}
//                                   </CustomSelect>
//                                   {props.touched.costFromVendor &&
//                                     props.errors.costFromVendor && (
//                                       <p className="text-danger">
//                                         {props.errors.costFromVendor}
//                                       </p>
//                                     )}
//                                 </div>
//                                 <div className="mb-3">
//                                   <label className="form-label required">
//                                     Invoice Num / PI Num
//                                   </label>
//                                   <CustomInput
//                                     name="invoiceNumber"
//                                     type="text"
//                                   />
//                                   {props.touched.invoiceNumber &&
//                                     props.errors.invoiceNumber && (
//                                       <p className="text-danger">
//                                         {props.errors.invoiceNumber}
//                                       </p>
//                                     )}
//                                 </div>
//                               </div>
//                               <div className="modal-footer">
//                                 <button
//                                   type="button"
//                                   className="btn btn-secondary"
//                                   data-bs-dismiss="modal"
//                                 >
//                                   Close
//                                 </button>
//                                 <FormSubmitButton
//                                   isSubmitting={props.isSubmitting}
//                                   buttonText="Submit"
//                                   data-bs-dismiss="modal"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </Form>
//                       )}
//                     </Formik>
//                   </div>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//       <div
//         key={new Date()}
//         className="modal modal-blur fade"
//         id={`modal-data`}
//         tabIndex="-1"
//         role="dialog"
//         aria-hidden="true"
//       >
//         <div
//           class="modal-dialog modal-lg modal-md modal-dialog-centered"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Vendors list</h5>
//               <span
//                 id="open-modal-data"
//                 data-bs-toggle="modal"
//                 data-bs-target={`#modal-data`}
//               ></span>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="table-responsive">
//                 <table className="table table-vcenter">
//                   <thead>
//                     <tr>
//                       {tableHead?.map((item, index) => {
//                         return <th key={index}>{item}</th>;
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {vendor &&
//                       vendor.map((item, index) => {
//                         return (
//                           <tr key={item?.id}>
//                             <td>{index + 1}</td>
//                             <td>{item?.businessName || "N/A"} </td>
//                             <td>{item?.contactPersonPhone || "N/A"}</td>
//                             <td>{item?.contactPersonEmail || "N/A"}</td>
//                             <td>{item?.state || "N/A"}</td>
//                             <td
//                               data-bs-dismiss="modal"
//                               className="cursor-pointer"
//                             >
//                               <CustomViewButton
//                                 onClick={() => goToView(item.id)}
//                               ></CustomViewButton>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         key={new Date()}
//         className="modal modal-blur fade"
//         id={`modal-history`}
//         tabIndex="-1"
//         role="dialog"
//         aria-hidden="true"
//       >
//         <div
//           class="modal-dialog modal-lg modal-md modal-dialog-centered"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Stock Update History</h5>
//               <span
//                 id="open-modal-history"
//                 data-bs-toggle="modal"
//                 data-bs-target={`#modal-history`}
//               ></span>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body m-0 p-0">
//               {!history || history?.length < 1 ? (
//                 <h3>No history available</h3>
//               ) : (
//                 <div className="table-responsive">
//                   {data && (
//                     <table className="table table-vcenter">
//                       <thead>
//                         <tr>
//                           <th>Date</th>
//                           <th>cost</th>
//                           <th>in stock</th>
//                           <th>cost From Vendor</th>
//                           <th>invoice / pi Num</th>
//                           <th>updated by</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {history?.map((lineItem, index) => {
//                           return (
//                             <tr key={index}>
//                               <td>
//                                 {lineItem?.date
//                                   ? extractDate(lineItem.date)
//                                   : "N/A"}
//                               </td>
//                               <td>{lineItem?.cost || "N/A"}</td>
//                               <td>{lineItem?.inStock || "N/A"}</td>
//                               <td>
//                                 {(
//                                   lineItem?.costFromVendor || "N/A"
//                                 ).toUpperCase()}
//                               </td>
//                               <td>{lineItem?.invoiceNumber || "N/A"}</td>
//                               <td>
//                                 {(lineItem?.generatedBy || "N/A").toUpperCase()}
//                               </td>
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </table>
//                   )}
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HydroponicInventoryTable;



import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { HydroponicMaterialInfo } from "../../../SchemaInfo/info";
import { AddItemHydroponicMaterial } from "../../../Schemas/Farm support/farmer_inventory_schema";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { IoPeopleSharp } from "react-icons/io5";
import CustomSelect from "../../../CustomComponent/custom_select";
import { extractDate } from "../../../Components/Functions/date.fun";
import LoadingPage from "../../../Components/layouts/loading";
const tableHead = [
  "Sr.",
  "Business name",
  "Contact Number",
  "contact Email",
  "state",
  "Actions",
];

const HydroponicInventoryTable = ({
  data = [],
  setRefresh,
  onTotalAmountChange,
  currentPage,
  itemsPerPage,
}) => {
  const store = useSelector((store) => store.login.user);
  const [inStock, setInStock] = useState([]);
  const [thresholdLimit, setThresholdLimit] = useState([]);
  const [cost, setCost] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [openhistoryModel, setOpenHistoryModel] = useState(false);
  const [history, setHistory] = useState(null);
   const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    setInStock(data?.map((item) => item?.inStock ?? ""));
    setThresholdLimit(data?.map((item) => item?.thresholdLimit ?? ""));
    setCost(data?.map((item) => item?.cost ?? ""));
  }, [data]);

  // useEffect(() => {
  //   if (openModel) {
  //     if (vendor.length > 0) {
  //       let ele = document.getElementById("open-modal-data");
  //       ele.click();
  //     } else {
  //       alert("No vendor available for this product");
  //     }
  //   }
  //   setOpenModel(false);
  // }, [vendor]);

  useEffect(() => {
    if (openModel && vendor?.length > 0) {
      let ele = document.getElementById("open-modal-data");
      ele.click();
     
      // reset AFTER opening
      setTimeout(() => {
        setOpenModel(false);
        // setLoading(false);
       
      }, 5000);
    }
  }, [openModel, vendor]);


  // useEffect(() => {
  //   if (openModel) {
  //     if (history && history.length > 0) {
  //       let ele = document.getElementById("open-modal-history");
  //       ele.click();
  //     } else {
  //       alert("No history available for this product");
  //     }
  //   }
  //   setOpenModel(false);
  // }, [history]);

  useEffect(() => {
    if (openhistoryModel && history?.length > 0) {
      let ele = document.getElementById("open-modal-history");
      ele.click();

      // reset AFTER opening
      setTimeout(() => {
        setOpenModel(false);
      }, 100);
    }
  }, [openhistoryModel, history]);


  useEffect(() => {
    const totalAmount = data.reduce((total, item, index) => {
      return (
        total + parseFloat(inStock[index] || 0) * parseFloat(cost[index] || 0)
      );
    }, 0);
    onTotalAmountChange(totalAmount);
  }, [data, inStock, cost, onTotalAmountChange]);
  const goToView = (id) => {
    navigate(`/purchase-vendor-management/view-vendor/${id}`);
  };
  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendorList(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }
    return costperUnit * inStock;
  };

  const handelSubmit = async (id, item, values, { resetForm }) => {
    try {
      const previousCost = parseFloat(item?.cost) || 0;
      const previousInStock = parseFloat(item?.inStock) || 0;
      const newCost = parseFloat(values?.cost) || 0;
      const newInStock = parseFloat(values?.inStock) || 0;
      if (!newCost || !newInStock) {
        Toast("error", "please add cost and stock items!");
        return;
      }
      const updatedCost =
        (previousInStock * previousCost + newInStock * newCost) /
        (previousInStock + newInStock);

      const updatedStock = previousInStock + newInStock;
      let stockUpdateHistory = [];
      if (item.stockUpdateHistory) {
        stockUpdateHistory = item.stockUpdateHistory;
      }

      stockUpdateHistory.push({
        cost: newCost,
        inStock: newInStock,
        costFromVendor: values.costFromVendor,
        date: new Date(),
        invoiceNumber: values.invoiceNumber,
        generatedBy: store.Name,
      });
      const updateData = {
        inStock: updatedStock,
        cost: parseFloat(updatedCost),
        stockUpdateHistory,
      };
      await performRequest(
        "PATCH",
        `/materialPlanning/updateMaterialList/${id}`,
        updateData
      );

      Toast("success", "Inventory updated successfully!");

      setCost((prev) => {
        if (!Array.isArray(prev)) return prev;
        const updated = [...prev];
        updated[id] = Number(updatedCost.toFixed(2));
        return updated;
      });

      resetForm();
      setRefresh((prev) => !prev);
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  let openVendorModel = (item) => {
    
    if (!item?.vendorDealsIn || item.vendorDealsIn.length === 0) {

      alert("No vendor available for this product");
      return;
    }
    setVendor(item?.vendorDealsIn);
    setOpenModel(true);
    // setLoading(true);
  };

  let openHistoryModel = (item) => {
    if (!item?.stockUpdateHistory || item.stockUpdateHistory.length === 0) {
      alert("No histrory available for this product");
      return;
    }

    setHistory(item?.stockUpdateHistory);
    setOpenHistoryModel(true);
  };

  const returnClassnameBg = (inStockValue, thresholdValue) => {
    const stock = Number(inStockValue || 0);
    const threshold = Number(thresholdValue || 0);
  
    if (stock === 0) {
      return {
        backgroundColor: "rgba(255, 99, 71, 0.2)",
      };
    }
  
    if (stock <= threshold) {
      return {
        backgroundColor: "rgba(255, 193, 7, 0.2)",
      };
    }
  
    return {
      backgroundColor: "rgba(144, 238, 144, 0.2)",
    };
  };

  const returnClassnameBadgeBg = (hydroponicType) => {
    switch (hydroponicType) {
      case "flatbed":
        return "text-white badge bg-primary mt-1 me-2"; // Blue
      case "dutch_bucket":
        return "text-white badge bg-success mt-1 me-2"; // Green
      case "planters":
        return "text-white badge bg-danger mt-1 me-2"; // Red
      case "growbags":
        return "text-white badge bg-info mt-1 me-2"; // Cyan
      default:
        return "text-white badge bg-warning mt-1 me-2"; // Yellow (default)
    }
  };

  const returnClassnameBadgeBgSize = (size) => {
    switch (size) {
      case "Small":
        return "badge bg-green-lt";
      case "Medium":
        return "badge bg-azure-lt";
      case "Large":
        return "badge bg-yellow-lt";
      case "Extra Large":
        return "badge bg-red-lt";
      case "Double Extra Large":
        return "badge bg-cyan-lt";
      default:
        return "badge bg-purple-lt";
    }
  };

  const clampStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

   if (loading) {
      return <LoadingPage />;
    }
  

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            <th style={{ minWidth: "170px" }}>SR./ Image/ SKU</th>
            <th style={{ minWidth: "200px" }}>Item/ size/ type</th>
            <th style={{ minWidth: "250px" }}>Specifications</th>
            <th>InStock/ Stock Value</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const inStockValue = parseFloat(inStock[index]) || 0;
            const thresholdValue = parseFloat(thresholdLimit[index]) || 0;
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr
                className="text-uppercase fs-5"
                key={item?.id}
                style={returnClassnameBg(inStockValue, thresholdValue)}
              >
                <td>
                  <img
                    width="140px"
                    length="140px"
                    src={item?.image}
                    alt="Not Uploaded"
                  />
                </td>
                <td style={{ maxWidth: "200px" }}>
                  <span className="fs-5 mt-2">
                    <b>
                      {Index}) {item?.sku}
                    </b>
                  </span>
                  <br className="m-0"></br>
                  <span>
                    <b> {item?.item || "N/A"}</b>
                  </span>
                  <br />
                  <span>
                    Size:{" "}
                    <b className={returnClassnameBadgeBgSize(item?.size)}>
                      {item?.size}
                    </b>
                  </span>
                  <br />
                  {item?.location && (
                    <>
                      <span className="m-0" style={{ fontSize: "11px" }}>
                        <b>Location: </b> {item.location || "-"}
                      </span>
                      <br className="m-0" />
                    </>
                  )}
                  {item?.rackId && (
                    <>
                      <span className="m-0" style={{ fontSize: "11px" }}>
                        <b>Rack Id: </b> {item?.rackId || "-"}{" "}
                      </span>
                      <br className="m-0" />
                    </>
                  )}
                  {item?.iteminList
                    ? (item?.hydroponicTypeNew ?? []).map((type, index) => (
                        <>
                          <span
                            key={index}
                            className={returnClassnameBadgeBg(type)}
                          >
                            {type || "N/A"}
                          </span>
                        </>
                      ))
                    : ""}
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex flex-wrap">
                    {(item?.specificationsNew ?? []).map((type, index) =>
                      type.specification ? (
                        <p className="p-0 m-0">
                          <b className="text-capitalize">{type?.type}</b>:{" "}
                          {type?.specification || "N/A"}
                        </p>
                      ) : (
                        "-"
                      )
                    )}
                  </div>
                  {item?.productSpecification && (
                    <div className="text-capitalize">
                      <b>Technical Specification: </b>
                      <span className="text-uppercase">
                        {item?.productSpecification}
                      </span>
                    </div>
                  )}
                </td>
                <td>
                  <span className="fs-3" style={{ fontWeight: "900" }}>
                    Instock: {item?.inStock || 0} / {item?.thresholdLimit || 0}
                  </span>
                  <br />
                  <span>
                    Cost:{" "}
                    <b>
                      ₹{item?.cost || 0}
                      {item?.proUnit ? `/ ${item?.proUnit}` : ""}
                    </b>
                  </span>
                  <br />
                  <span>
                    Total:{" "}
                    <b>
                      {roundOffCost(
                        getPrice(
                          item?.inStock,
                          item?.cost,
                          item?.weight,
                          item?.proUnit
                        )
                      )}
                    </b>
                  </span>
                  <br />
                  {item?.brandName && (
                    <span className="m-0 badge badge bg-azure-lt border mt-1">
                      Brand Name: <b>{item?.brandName}</b>
                    </span>
                  )}
                </td>

                <td>
                  <div className="row g-2">
                    <div className="col-12">
                      <button
                        className="btn btn-sm btn-primary text-uppercase w-100"
                        data-bs-toggle="modal"
                        data-bs-target={`#modal-team-${item?.id}`}
                      >
                        Add Item
                      </button>
                    </div>

                    <div className="col-lg-3">
                      <button className="btn btn-sm btn-primary text-uppercase w-100">
                        <IoPeopleSharp
                          style={{ fontSize: "16px", color: "white" }}
                          // onClick={() => {
                          //   setOpenModel(true);
                          //   setVendor(item?.vendorDealsIn || []);
                          // }}
                          onClick={() => openVendorModel(item)}
                        />
                      </button>
                    </div>
                    <div className="col-lg">
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                        store.Role === process.env.REACT_APP_ROLE_PURCHASE) && (
                        <button
                          className="btn btn-sm btn-primary text-uppercase w-100"
                          onClick={() =>
                            navigate(
                              `/hydroponic-material-inventory/edit/${item.id}`
                            )
                          }
                        >
                          Edit Item
                        </button>
                      )}
                    </div>
                    <div className="col-lg">
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                        store.Role === process.env.REACT_APP_ROLE_PURCHASE) && (
                        <button
                          className="btn btn-sm btn-primary text-uppercase w-100"
                          // onClick={() => {
                          //   setOpenModel(true);
                          //   setHistory(item.stockUpdateHistory);
                          // }}
                          onClick={() => openHistoryModel(item)}
                        >
                          History
                        </button>
                      )}
                    </div>
                  </div>
                  <br />
                  <div
                    className="modal modal-blur fade"
                    id={`modal-team-${item?.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <Formik
                      initialValues={HydroponicMaterialInfo}
                      validationSchema={AddItemHydroponicMaterial}
                      onSubmit={(values, actions) =>
                        handelSubmit(item?.id, item, values, actions)
                      }
                      enableReinitialize
                    >
                      {(props) => (
                        <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                          <div className="modal-dialog modal-dialog-centered w-100">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Add Items</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body">
                                <div className="mb-3">
                                  <label className="form-label required">
                                    Add item in stock
                                  </label>
                                  <CustomInput name="inStock" type="text" />
                                  {props.touched.inStock &&
                                    props.errors.inStock && (
                                      <p className="text-danger">
                                        {props.errors.inStock}
                                      </p>
                                    )}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label required">
                                    Cost per unit
                                  </label>
                                  <CustomInput name="cost" type="text" />
                                  {props.touched.cost && props.errors.cost && (
                                    <p className="text-danger">
                                      {props.errors.cost}
                                    </p>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label">
                                    Cost from vendor
                                  </label>
                                  <CustomSelect
                                    type="text"
                                    name="costFromVendor"
                                  >
                                    <option value="">Select</option>
                                    {vendorList?.map((item) => {
                                      return (
                                        <option
                                          key={item.id}
                                          value={item.businessName}
                                        >
                                          {item.businessName}
                                        </option>
                                      );
                                    })}
                                  </CustomSelect>
                                  {props.touched.costFromVendor &&
                                    props.errors.costFromVendor && (
                                      <p className="text-danger">
                                        {props.errors.costFromVendor}
                                      </p>
                                    )}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label required">
                                    Invoice Num / PI Num
                                  </label>
                                  <CustomInput
                                    name="invoiceNumber"
                                    type="text"
                                  />
                                  {props.touched.invoiceNumber &&
                                    props.errors.invoiceNumber && (
                                      <p className="text-danger">
                                        {props.errors.invoiceNumber}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                                <FormSubmitButton
                                  isSubmitting={props.isSubmitting}
                                  buttonText="Submit"
                                  data-bs-dismiss="modal"
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div
        // key={new Date()}
        className="modal modal-blur fade"
        id={`modal-data`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Vendors list</h5>
              <span
                id="open-modal-data"
                data-bs-toggle="modal"
                data-bs-target={`#modal-data`}
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-vcenter">
                  <thead>
                    <tr>
                      {tableHead?.map((item, index) => {
                        return <th key={index}>{item}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {vendor &&
                      vendor.map((item, index) => {
                        return (
                          <tr key={item?.id}>
                            <td>{index + 1}</td>
                            <td>{item?.businessName || "N/A"} </td>
                            <td>{item?.contactPersonPhone || "N/A"}</td>
                            <td>{item?.contactPersonEmail || "N/A"}</td>
                            <td>{item?.state || "N/A"}</td>
                            <td
                              data-bs-dismiss="modal"
                              className="cursor-pointer"
                            >
                              <CustomViewButton
                                onClick={() => goToView(item.id)}
                              ></CustomViewButton>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        key={new Date()}
        className="modal modal-blur fade"
        id={`modal-history`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Stock Update History</h5>
              <span
                id="open-modal-history"
                data-bs-toggle="modal"
                data-bs-target={`#modal-history`}
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body m-0 p-0">
              {!history || history?.length < 1 ? (
                <h3>No history available</h3>
              ) : (
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>cost</th>
                          <th>in stock</th>
                          <th>cost From Vendor</th>
                          <th>invoice / pi Num</th>
                          <th>updated by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {history?.map((lineItem, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {lineItem?.date
                                  ? extractDate(lineItem.date)
                                  : "N/A"}
                              </td>
                              <td>{lineItem?.cost || "N/A"}</td>
                              <td>{lineItem?.inStock || "N/A"}</td>
                              <td>
                                {(
                                  lineItem?.costFromVendor || "N/A"
                                ).toUpperCase()}
                              </td>
                              <td>{lineItem?.invoiceNumber || "N/A"}</td>
                              <td>
                                {(lineItem?.generatedBy || "N/A").toUpperCase()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HydroponicInventoryTable;
